module.exports = __webpack_public_path__ + "img/gate_thumb.fe22bce3.jpg";